module.exports = __webpack_public_path__ + "img/IMG_8086.9ec77224.jpg";